// extracted by mini-css-extract-plugin
export default {"GoBack":"ForgotPwdForm_GoBack__ww1Hm","backLogin":"ForgotPwdForm_backLogin__ibYRd"};